import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Brain, AlertTriangle, TrendingUp, PieChart, FileBarChart, Radio } from "lucide-react";
import { ListeningDashboardV2 } from "./ListeningDashboardV2";
import { CrisisCenter } from "./CrisisCenter";
import { SentimentAnalytics } from "./SentimentAnalytics";
import { ShareOfVoice } from "./ShareOfVoice";
import { MonthlyReports } from "./MonthlyReports";

const TABS = [
  { value: "listening",  label: "Listening",        Icon: Radio },
  { value: "crisis",     label: "Crisis Center",     Icon: AlertTriangle },
  { value: "sentiment",  label: "Sentiment",         Icon: TrendingUp },
  { value: "sov",        label: "Share of Voice",    Icon: PieChart },
  { value: "reports",    label: "Monthly Reports",   Icon: FileBarChart },
];

export function IntelligenceView({ showHeader = true }: { showHeader?: boolean }) {
  const [tab, setTab] = useState("listening");

  return (
    <div className="space-y-6">
      {showHeader && (
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-[#0D2240] flex items-center justify-center">
            <Brain className="w-4 h-4 text-[#C8A84B]" />
          </div>
          <div>
            <h2 className="text-2xl font-bold">Intelligence</h2>
            <p className="text-muted-foreground text-sm">Media intelligence, crisis monitoring, and performance analytics.</p>
          </div>
        </div>
      )}

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex flex-wrap gap-1 h-auto p-1">
          {TABS.map(({ value, label, Icon }) => (
            <TabsTrigger key={value} value={value} className="flex items-center gap-1.5 text-xs px-3 py-1.5">
              <Icon className="w-3.5 h-3.5" />
              {label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="listening"  className="mt-4"><ListeningDashboardV2 /></TabsContent>
        <TabsContent value="crisis"     className="mt-4"><CrisisCenter /></TabsContent>
        <TabsContent value="sentiment"  className="mt-4"><SentimentAnalytics /></TabsContent>
        <TabsContent value="sov"        className="mt-4"><ShareOfVoice /></TabsContent>
        <TabsContent value="reports"    className="mt-4"><MonthlyReports /></TabsContent>
      </Tabs>
    </div>
  );
}
